import { isRejected } from '@reduxjs/toolkit'
import { useToasts } from 'react-toast-notifications'
import React, { FC, useEffect, useMemo } from 'react'

import { useDispatch, useSelector } from '../../store'
import { googleAuthThunk } from '../../store/auth/thunks'

import './ButtonGoogleAuth.scss'
import { TOAST_MESSAGE } from '../UI/ToastNotification/ToastNotification'

interface ButtonGoogleAuthProps { }

const ButtonGoogleAuth: FC<ButtonGoogleAuthProps> = (props) => {
  const location = useSelector((state) => state.router.location)
  const dispatch = useDispatch()
  const api = process.env.REACT_APP_BASE_URL

  const { addToast } = useToasts()

  const isValidQuery = (query: any) => {
    return query.code && query.prompt && query.scope && query.state
  }

  useEffect(() => {
    if (isValidQuery((location as any).query)) {
      const responseGoogleAuth = dispatch(googleAuthThunk(location.search))
      if (isRejected(responseGoogleAuth) && (responseGoogleAuth.payload as any).error.status === 401) {
        addToast(TOAST_MESSAGE.ACCOUNT_WAS_BLOCKED, { appearance: 'error' })
      }
    }
  }, [location, dispatch])

  const buttonText = useMemo(() => {
    if (location.pathname === '/') {
      return 'Log in with Google'
    } else {
      return 'Log on with Google'
    }
  }, [location])

  return (
    <>
      <button onClick={() => (window.location.href = `${api}/auth/google`)} className='google-auth'>
        <div className='google-icon'></div>
        {buttonText}
      </button>
    </>
  )
}
export default ButtonGoogleAuth
